import { useQuery } from '@tanstack/react-query';
import { CAR_PROPERTIES, getCarPropertyByIdSelector, getCarSelector, getOnlinePriceData, isRiskFree } from '@wkda/funnel-modules';
import { useParams } from 'react-router-dom';
import { useGetConsumerCarlead } from '../../hooks/useDataHooks';
import { useGetConsumerCarleadPrices } from '../../hooks/useDataHooks/useGetConsumerCarleadPrices';
import { useModulesStore } from '../../hooks/useModules';
import { useBookingAppConfiguration } from './useBookingAppConfiguration';
const HANDOVER_PRICE_EXPIRED_SUFFIX = 'i';
const isExpiredPriceHandoverPage = urlParams => urlParams.profileSuffix?.toLocaleLowerCase() === HANDOVER_PRICE_EXPIRED_SUFFIX;
export function useHandoverProps() {
  const {
    data: consumerCarlead,
    isLoading
  } = useGetConsumerCarlead();
  const params = useParams();
  const config = useBookingAppConfiguration();
  const {
    inspectionModule
  } = useModulesStore();
  const isSelfEvalutation = getCarPropertyByIdSelector(consumerCarlead, CAR_PROPERTIES.ONLINE_SELF_EVALUATION)?.value === 'online-self-evaluation';
  const isAssumption = getCarPropertyByIdSelector(consumerCarlead, CAR_PROPERTIES.SELF_EVALUATION_ASSUMPTION)?.value === 'true';
  const {
    data
  } = useQuery({
    queryKey: ['reevaluationApplicable', consumerCarlead?.hash],
    queryFn: () => inspectionModule.getReevaluationApplicability(consumerCarlead?.hash),
    enabled: Boolean(config.selfReevaluationLink) && !isLoading,
    refetchOnMount: false,
    refetchOnWindowFocus: false
  });
  const car = getCarSelector(consumerCarlead);
  const priceData = getOnlinePriceData(consumerCarlead);
  const comparePriceData = useGetConsumerCarleadPrices(priceData, Boolean(config.handoverPriceComparison) && !isLoading);
  return {
    isRiskFree: isRiskFree(consumerCarlead),
    hasValidBid: consumerCarlead?.hasValidBid,
    priceExpired: consumerCarlead?.priceExpired,
    priceExpiresInDays: consumerCarlead?.priceExpiresInDays || 0,
    isExpiredPriceHandoverPage: isExpiredPriceHandoverPage(params),
    selfReevaluationLink: config.selfReevaluationLink,
    isReevaluationApplicable: Boolean(data?.isReevaluationApplicable),
    hash: consumerCarlead?.hash,
    car,
    isLoading,
    isSelfEvalutation,
    isAssumption,
    ...priceData,
    ...comparePriceData
  };
}